import React, { Dispatch, SetStateAction, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../store/hook';
import {
  getDeliveryInfoList,
  selectDeliveryList,
  setDeliveryInfo,
  setEditDeliveryInfo,
} from '../../store/features/orderInfoSlice';
import DeliveryInfoCard from './DeliveryInfoCard';
import Buttons from '../common/Buttons';
import { DeliveryProps } from '../../constants/types';
interface DeliveryInfoListProps {
  setState: Dispatch<SetStateAction<'form' | 'none' | 'list'>>;
}
const DeliveryInfoList = ({ setState }: DeliveryInfoListProps) => {
  const dispatch = useAppDispatch();
  const deliveryList = useAppSelector(selectDeliveryList);

  // 기본 배송지를 첫 번째로 정렬
  const sortedDeliveryList = [...deliveryList].sort((a, b) => {
    if (a.isDefault && !b.isDefault) return -1;
    if (!a.isDefault && b.isDefault) return 1;
    return 0;
  });

  useEffect(() => {
    dispatch(getDeliveryInfoList({ url: 'v1/shipping', params: {} }));
  }, []);

  const selectItem = (deliveryInfo: DeliveryProps) => {
    dispatch(setDeliveryInfo(deliveryInfo));
    setState('none');
  };

  const addDeliveryInfo = () => {
    dispatch(setEditDeliveryInfo(undefined));
    setState('form');
  };

  return (
    <div>
      <div className="mt-[-16px] max-h-[70vh] overflow-auto">
        {sortedDeliveryList.length > 0 ? (
          sortedDeliveryList.map((delivery, index) => (
            <DeliveryInfoCard
              key={index}
              deliveryInfo={delivery}
              onClick={() => selectItem(delivery)}
              editable={true}
              setState={setState}
            />
          ))
        ) : (
          <div className="flex h-[100px] items-center justify-center text-gray5">
            등록된 배송지가 없습니다.
          </div>
        )}
      </div>
      <Buttons
        type={'filled'}
        color={'purple5'}
        onClick={() => addDeliveryInfo()}
        className="mt-4"
      >
        <span>배송지 추가</span>
      </Buttons>
    </div>
  );
};
export default DeliveryInfoList;
